import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";
import { appPublish } from "../../InterfacesAndComponents/stringUtils";

const NativeMobileApplicationOverview = ({ data }) => {
  const {
    native_mobile_application_would_you_like_mobile_app,
    native_mobile_application_native_platform,
    native_mobile_application_mobile_language,
    native_mobile_application_mobile_language_other,
    native_mobile_application_mobile_app_publishing,
  } = data["3_4"];

  const languageValue = [
    ...(native_mobile_application_mobile_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(native_mobile_application_mobile_language?.includes("other") &&
    native_mobile_application_mobile_language_other?.length
      ? [`Other (${toTitleCase(native_mobile_application_mobile_language_other)})`]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="Native Mobile Application (C-Holder Mobile)" />
        </div>
        <ReviewAttribute
          label="Would you like Mobile Application?"
          value={
            native_mobile_application_would_you_like_mobile_app?.length
              ? toTitleCase(native_mobile_application_would_you_like_mobile_app)
              : "-"
          }
        />
                <ReviewAttribute
          label="Native Platform"
          value={native_mobile_application_native_platform?.length
            ? toTitleCase(native_mobile_application_native_platform.join(", "))
            : "-"}
        />
        <ReviewAttribute
          label="C-Holder Mobile Language"
          value={languageValue || "-"}
        />

        <ReviewAttribute
          label="How will the mobile application be published:"
          value={
            native_mobile_application_mobile_app_publishing?.length
              ? appPublish.find((app) => app.value === native_mobile_application_mobile_app_publishing)?.label || native_mobile_application_mobile_app_publishing
              : "-"
          }
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default NativeMobileApplicationOverview;
